<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Recaudaciones</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button v-show="
            !recaudacionesConsultadas &&
            !mostrandoAsignaciones &&
            !asignandoItems
          " type="button" @click="asignarItems" class="btn-primary">
            <i class="fa fa-table"></i><span>Asignación de ítems</span>
          </button>
          <button v-show="!mostrandoAsignaciones && !asignandoItems" class="btn-secondary" type="button"
            @click="recaudacionesAsignadas">
            <i class="fa fa-list"></i><span>Recaudaciones asignadas</span>
          </button>
          <button type="button" @click="mostrarHistoricos" class="btn-secondary"
            v-show="asignandoItems || mostrandoAsignaciones">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button type="button" @click="cancelarAsignacionItems" class="btn-danger btn--bigger"
            v-show="asignandoItems || mostrandoAsignaciones">
            <i class="fa fa-ban"></i><span>Cancelar</span>
          </button>
          <!-- <button v-show="asignandoItems || mostrandoAsignaciones" type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button> -->
          <!-- <label
            v-show="
              !recaudacionesConsultadas &&
              !asignandoItems &&
              !mostrandoAsignaciones
            "
            for="cambiar_orden"
          >
            <input
              v-model="cambiarOrden"
              type="checkbox"
              name="cambiar_orden"
              @change="changeCambiarOrden"
              id="cambiar_orden"
            /><span>Ordenar recaudaciones</span>
          </label> -->
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div v-show="!cambiarOrden && !asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select name="tipo_fecha" v-model="form.tipo_fecha" id="tipo_fecha">
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizada</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P' && !cambiarOrden && !asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="desde" v-model="form.desde" locale="es" only-date no-label
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione fecha..." />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P' && !cambiarOrden && !asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="hasta" v-model="form.hasta" locale="es" only-date no-label
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione fecha..." />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div v-show="cambiarOrden || asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="fecha" v-model="form.fecha" locale="es" only-date no-label
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD" label="Seleccione fecha..."
                  :disabled="recaudacionesConsultadas && asignandoItems" />
                <label>Fecha</label>
              </div>
            </div>
          </div>
          <div v-show="cambiarOrden || asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select name="dia_cobro" v-model="form.dia_cobro" id="dia_cobro">
                  <option disabled value="">Seleccione...</option>
                  <option value="1">Lunes</option>
                  <option value="2">Martes</option>
                  <option value="3">Miércoles</option>
                  <option value="4">Jueves</option>
                  <option value="5">Viernes</option>
                  <option value="6">Sábado</option>
                  <option value="7">Domingo</option>
                </select>
                <label for="dia_cobro">Día de cobro</label>
              </div>
            </div>
          </div>
          <div v-show="cambiarOrden || asignandoItems || mostrandoAsignaciones" class="col-xs-12 col-md-4">
            <div class="form-field select2" :class="{
              'select2--disabled': recaudacionesConsultadas,
            }">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." :options="rutas" id="ruta" name="ruta" @input="inputRuta"
                  v-model="selectedRuta" @search="searchRutas" label="descripcion"></v-select>
                <label for="ruta">Ruta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." :options="recaudadores" id="recaudador" name="recaudador"
                  @input="inputRecaudador" v-model="selectedRecaudador" @search="searchRecaudadores" label="nombre">
                </v-select>
                <label for="recaudador">Recaudador</label>
              </div>
            </div>
          </div>
          <div v-show="mostrandoAsignaciones" class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  label="descripcion"
                  @input="inputBodega"
                  placeholder="Seleccione..."
                  id="bodega_id"
                  v-model="selectedBodega"
                  :options="bodegas"
                ></v-select>
                <label for="bodega_id">Sucursal</label>
              </div>
            </div>
          </div>
          <div v-show="asignandoItems" class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." :options="supervisores" id="supervisor" name="supervisor"
                  @input="inputSupervisor" v-model="selectedSupervisor" @search="searchSupervisores" label="nombre">
                </v-select>
                <label for="supervisor">Supervisor</label>
              </div>
            </div>
          </div>
          <div v-show="asignandoItems && recaudacionesConsultadas" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="form-group">
                <input-field id="referencia_movimiento" v-model="form.referencia_movimiento"
                  :readonly="form.items.length > 0" placeholder="Referencia de movimiento...">
                  Movimiento
                </input-field>
                <button type="button" @click="confirmarMovimiento" v-show="form.items.length == 0"
                  class="btn-success btn--text">
                  <i class="fa fa-check"></i>
                  <span>Confirmar</span>
                </button>
                <button v-show="form.items.length > 0" type="button" @click="quitarMovimiento()"
                  class="btn-danger btn--text">
                  <i class="fa fa-times"></i>
                  <span>Anular</span>
                </button>
                <button v-show="form.items.length > 0" type="button" @click="actualizarRecaudacion"
                  class="btn-success btn--text">
                  <i class="fa fa-save"></i>
                  <span>Actualizar</span>
                </button>
                <button type="button" @click="verMovimiento" class="btn-info btn--text">
                  <i class="fa fa-eye"></i>
                  <span>Ver</span>
                </button>
              </div>
            </div>
          </div>
          <div v-show="!cambiarOrden && !asignandoItems && !mostrandoAsignaciones" class="col-xs-12 col-md-4">
            <div class="form-field">
              <input-field id="consulta" v-model="form.consulta" placeholder="Número de documento o cliente...">
                Consulta
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="asignandoItems && form.recaudacion_id != ''" class="card mt-2 mb-2">
      <div class="card__content">
        <items-adicionales :ruta_id="form.ruta_id" 
          v-model="form.movimientosAdicionales" :recaudacionId="form.recaudacion_id"></items-adicionales>
      </div>
    </div>
    <k-table @verVisita="verVisita" @verVenta="verVenta"
      v-show="!cambiarOrden && !asignandoItems && !mostrandoAsignaciones" :params="form" :buttons="[
        {
          event: 'verVisita',
          icon: 'fa-table',
          class: 'btn-info btn--text',
          text: 'Visita',
        },
        {
          event: 'verVenta',
          icon: 'fa-eye',
          class: 'btn-success btn--text',
          text: 'Venta',
        },
      ]" ref="recaudaciones" :buscarButton="false" :filterStatus="false" :path="path" :createButton="false"
      :editButton="false" :deleteButton="false" :columns="[
        {
          display: 'Fecha de venta',
          value: 'fecha',
        },
        {
          display: 'Ruta',
          value: 'descripcion_ruta'
        },
        {
          display: 'Vendedor',
          value: 'descripcion_vendedor'
        },
        {
          display: 'Fecha de recaudación',
          value: 'fecha_recaudacion',
        },
        {
          display: 'Día de recaudación',
          value: 'descripcion_dia_cobro',
        },
        {
          display: 'Tipo',
          value: 'tipo_documento',
        },
        {
          display: '# Cartilla',
          value: 'numero_documento',
        },
        {
          display: 'Recaudador',
          value: 'nombre_recaudador',
        },
        {
          display: 'Cliente',
          value: 'nombre_cliente',
        },
        {
          display: 'Observación',
          value: 'observación',
        },
        {
          display: '# Pagos',
          value: 'numero_pagos',
        },
        {
          display: 'Venta total',
          value: 'venta_total',
        },
        {
          display: 'V. Pagos',
          value: 'valor_pagos',
        },
        {
          display: 'Saldo',
          value: 'saldo_total',
        },
      ]"></k-table>
    <k-table @reportar="reportar" @anular="anularRecaudacion" @verItems="verItems" @verCartillas="verCartillas" @verRubros="verRubros" @exportar="exportar" :buttons="[
      {
        event: 'verItems',
        icon: 'fa-list',
        class: 'btn-info btn--text',
        text: '´Ítems',
      },
      {
        event: 'verCartillas',
        icon: 'fa-table',
        class: 'btn-primary btn--text',
        text: 'Cartillas',
      },
      {
        event: 'verRubros',
        icon: 'fa-money',
        class: 'btn-secondary btn--text',
        text: 'Rubros',
      },
      {
        event: 'exportar',
        icon: 'fa-file-excel-o',
        class: 'btn-success btn--text',
        text: 'Exportar',
      },
      {
        event: 'reportar',
        icon: 'fa-share',
        class: 'btn-warning btn--text',
        text: 'Reportar',
      },
      {
        event: 'anular',
        icon: 'fa-trash',
        class: 'btn-danger btn--text',
        text: 'Anular',
      }
    ]" v-show="mostrandoAsignaciones" :params="form" ref="recaudacionesAsignadas" :buscarButton="false"
      :filterStatus="false" :path="pathRecaudaciones" :createButton="false" :editButton="false" :deleteButton="false"
      :columns="[
        {
          display: 'Fecha',
          value: 'fecha_formateada',
        },
        {
          display: 'Ref. Movimiento',
          value: 'referencia_movimiento',
        },
        {
          display: 'Recaudador',
          value: 'recaudador.nombre',
        },
        {
          display: 'Ruta',
          value: 'ruta.nombre',
        },
        {
          display: 'Día de cobro',
          value: 'descripcion_dia_cobro',
        },
        {
          display: 'Estado',
          value: 'estado_recaudacion',
        },
        {
          display: 'Creador',
          value: 'creador.nombre',
        },
        {
          display: 'Creación',
          value: 'created_at',
        },
        {
          display: 'Modificador',
          value: 'modificador.nombre',
        },
        {
          display: 'Fecha inicio',
          value: 'fecha_inicio',
        },
        {
          display: 'Fecha fin',
          value: 'fecha_fin',
        }
      ]"></k-table>
    <div class="card" v-show="(cambiarOrden || asignandoItems) && !mostrandoAsignaciones">
      <div class="card__content">
        <table>
          <thead>
            <tr>
              <th>Orden</th>
              <th>Fecha de venta</th>
              <th>Fecha de recaudación</th>
              <th>Día de recaudación</th>
              <th>Tipo</th>
              <th># Cartilla</th>
              <th>Cliente</th>
              <th>Observación</th>
              <th># Pagos</th>
              <th>Venta total</th>
              <th>V. Pagos</th>
              <th>Saldo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(recaudacion, index) in recaudaciones" :key="recaudacion.id">
              <td>{{ index + 1 }}</td>
              <td>
                {{ recaudacion.fecha }}
              </td>
              <td>
                {{ recaudacion.fecha_recaudacion }}
              </td>
              <td>
                {{ recaudacion.descripcion_dia_cobro }}
              </td>
              <td>
                {{ recaudacion.tipo_documento }}
              </td>
              <td>
                {{ recaudacion.numero_documento }}
              </td>
              <td>
                {{ recaudacion.nombre_cliente }}
              </td>
              <td>
                {{ recaudacion.observacion }}
              </td>
              <td>
                {{ recaudacion.numero_pagos }}
              </td>
              <td>
                {{ moneyFormat(recaudacion.venta_total) }}
              </td>
              <td>
                {{ moneyFormat(recaudacion.valor_pagos) }}
              </td>
              <td>
                {{ moneyFormat(recaudacion.saldo) }}
              </td>
              <td>
                <button @click="subir(index)" v-show="index > 0 && !asignandoItems" class="btn-primary btn--text">
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button @click="bajar(index)" v-show="index < recaudaciones.length - 1 && !asignandoItems"
                  class="btn-primary btn--text">
                  <i class="fa fa-arrow-down"></i>
                </button>
              </td>
            </tr>
            <tr v-show="recaudaciones.length === 0">
              <td colspan="10">No hay resultados disponibles.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal name="itemsRecaudaciones" height="auto" width="60%" scrollable adaptive resizable>
      <items-recaudaciones :ruta_id="form.ruta_id" @cerrar="$modal.hide('itemsRecaudaciones')" @aceptar="aceptarItems"
        :soloConsulta="consultaItemsRecaudaciones" :referenciaMovimiento="form.referencia_movimiento">
      </items-recaudaciones>
    </modal>
    <modal name="itemsConsultaRecaudaciones" height="auto" width="60%" scrollable adaptive resizable>
      <items-consulta-recaudaciones @cerrar="$modal.hide('itemsConsultaRecaudaciones')"
        :recaudacionId="currentRecaudacionId"></items-consulta-recaudaciones>
    </modal>
    <modal name="cartillasRecaudacion" width="80%" height="auto" scrollable reset adaptive resizable>
      <cartillas-recaudacion :recaudacionId="currentRecaudacionId" @cerrar="$modal.hide('cartillasRecaudacion')">
      </cartillas-recaudacion>
    </modal>
    <modal name="rubrosRecaudacion" width="80%" height="auto" scrollable reset adaptive resizable>
      <rubros-recaudacion :recaudacionId="currentRecaudacionId" @cerrar="$modal.hide('rubrosRecaudacion')">
      </rubros-recaudacion>
    </modal>
    <modal name="historicos" height="auto" width="70%" scrollable adaptive resizable reset>
      <reportes-historicos-excel tipoReporte='rec'></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
import CartillasRecaudacion from "./CartillasRecaudacion.vue";
import ItemsRecaudaciones from "./ItemsRecaudaciones.vue";
import itemsConsultaRecaudaciones from "./ItemsConsultaRecaudaciones.vue";
import RubrosRecaudacion from './RubrosRecaudacion.vue';
import ItemsAdicionales from './ItemsAdicionales.vue';
export default {
  computed: {
    diaCobro: function () {
      let day = moment(new Date(this.form.fecha + " 00:00:00")).day();
      switch (day) {
        case 1:
          return "Lunes";
        case 2:
          return "Martes";
        case 3:
          return "Miércoles";
        case 4:
          return "Jueves";
        case 5:
          return "Viernes";
        case 6:
          return "Sábado";
        case 0:
          return "Domingo";
      }
      return "No definido";
    },
  },
  components: {
    ItemsRecaudaciones,
    itemsConsultaRecaudaciones,
    CartillasRecaudacion,
    RubrosRecaudacion,
    ItemsAdicionales
  },
  props: {
    reordenar_recaudaciones: {
      type: Boolean,
      required: false,
      default: false,
    },
    bodegas: {
      type: Array,
      required: false,
      default: () => {}
    }
  },
  data: function () {
    return {
      selectedSupervisor: null,
      currentRecaudacionId: "",
      pathRecaudaciones: url + "/logistica/recaudaciones-asignadas",
      mostrandoAsignaciones: false,
      selectedRuta: null,
      selectedBodega: null,
      rutas: [],
      cambiarOrden: false,
      path: url + "/logistica/recaudaciones",
      form: {
        tipo_fecha: "H",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        recaudador_id: "",
        consulta: "",
        fecha: moment(new Date()).format("YYYY-MM-DD"),
        referencia_movimiento: "",
        items: [],
        ruta_id: "",
        dia_cobro: "",
        recaudacion_id: '',
        movimientosAdicionales: [],
        supervisor_id: '',
        bodega_id: ''
      },
      recaudadores: [],
      selectedRecaudador: null,
      selectedSupervisor: null,
      recaudaciones: [],
      moneyFormat: moneyFormat,
      asignandoItems: false,
      recaudacionesConsultadas: false,
      consultaItemsRecaudaciones: true,
      supervisores: []
    };
  },
  methods: {
    reportar: function (recaudacion) {
      window.open(url + '/reporte-cobranza?fecha=' + recaudacion.fecha + '&ruta_id=' + recaudacion.ruta_id + '&recaudador_id=' + recaudacion.recaudador_id, '_blank');
    },
    anularRecaudacion: function (recaudacion) {
      this.quitarMovimiento(recaudacion);
    },
    exportar: function (row) {
      const { id } = row;
      this.form.items.splice(0, this.form.items.length);
      // this.$refs.recaudacionesAsignadas.exportar();
      let queryString = this.serialize(this.form) + "&exportar=true&recaudacion_id=" + id;
      window.open(url + "/logistica/recaudaciones-asignadas" + queryString, "_blank");
    },
    verRubros: function (row) {
      this.currentRecaudacionId = row.id;
      this.$modal.show('rubrosRecaudacion');
    },
    verCartillas: function (row) {
      this.currentRecaudacionId = row.id;
      this.$modal.show('cartillasRecaudacion');
    },
    verItems: function (row) {
      this.currentRecaudacionId = row.id;
      this.$modal.show("itemsConsultaRecaudaciones");
    },
    recaudacionesAsignadas: function () {
      this.mostrandoAsignaciones = true;
    },
    actualizarRecaudacion: function () {
      swal({
        title: "¿Deseas actualizar los datos de la recaudación?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.aceptarItems(this.form.items);
        }
      }).catch(({response}) => {
        if (response.status == 410) {
          swal('No se puede modificar la recaudación ya que ha sido iniciada.', 'Aviso', 'warning');
        }
        else 
          swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    searchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/rutas?search=" + search + "&fecha=" + this.form.fecha,
        true
      );
      xmlhttp.send();
    },
    aceptarItems: function (items) {
      axios
        .post(url + "/logistica/items-recaudaciones", {
          fecha: this.form.fecha,
          recaudador_id: this.form.recaudador_id,
          referencia_movimiento: this.form.referencia_movimiento,
          items: items,
          ruta_id: this.form.ruta_id,
          dia_cobro: this.form.dia_cobro,
          supervisor_id: this.form.supervisor_id
        })
        .then(({ data }) => {
          this.form.recaudacion_id = data.id;
          this.form.items = items;
          this.$modal.hide("itemsRecaudaciones");
          swal(
            "La recaudación fue registrada exitósamente.",
            "Realizado",
            "success"
          );
        })
        .catch(({ response }) => {
          if (response.status == 409) {
            swal('El recaudador ya ha sido asignado en ruta la fecha seleccionada, no se puede continuar.', 'Aviso', 'warning');
          }
          else if (response.status == 410) {
            swal('No se puede modificar la recaudación ya que ha sido iniciada.', 'Aviso', 'warning');
          }
          else
            swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    confirmarMovimiento: function () {
      if (this.selectedRecaudador == null) {
        swal("Debe seleccionar un recaudador.", "Aviso", "warning");
        return;
      }
      if (
        this.form.referencia_movimiento != "" &&
        this.form.referencia_movimiento != null
      ) {
        this.consultaItemsRecaudaciones = false;
        this.$modal.show("itemsRecaudaciones");
      } else {
        swal(
          "Debe indicar el número de movimiento de referencia.",
          "Aviso",
          "warning"
        );
      }
    },
    quitarMovimiento: function (recaudacion = null) {
      swal({
        title: "¿Deseas anular la recaudación?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/items-recaudaciones", {
              fecha: recaudacion == null?this.form.fecha:recaudacion.fecha,
              ruta_id: recaudacion == null?this.form.ruta_id:recaudacion.ruta_id,
              _method: "DELETE",
            })
            .then(() => {
              this.form.referencia_movimiento = "";
              this.form.movimientosAdicionales.splice(0, this.form.movimientosAdicionales.length);
              this.form.items.splice(0, this.form.items.length);
              swal(
                "Se ha anulado la recaudación seleccionada.",
                "Realizado",
                "success"
              );
              this.consultar();
            })
            .catch(({response}) => {
              if (response.status === 410) {
                swal('No se puede anular la recaudación ya que ha sido iniciada.', 'Aviso', 'warning');
              }
              else 
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    verMovimiento: function () {
      this.consultaItemsRecaudaciones = true;
      this.$modal.show("itemsRecaudaciones");
    },
    cancelarAsignacionItems: function () {
      this.recaudacionesConsultadas = false;
      this.asignandoItems = false;
      this.mostrandoAsignaciones = false;
      this.recaudaciones.splice(0, this.recaudaciones.length);
      this.form.recaudacion_id = '';
    },
    verVenta: function (venta) {
      window.open(url + "/logistica/pedidos/" + venta.id + "/edit", "_blank");
    },
    verVisita: function (visita) {
      window.open(
        url + "/logistica/visitas/" + visita.visita_id + "/edit",
        "_blank"
      );
    },
    changeCambiarOrden: function () {
      if (this.cambiarOrden) this.asignandoItems = false;
    },
    asignarItems: function () {
      this.asignandoItems = true;
      this.cambiarOrden = false;
    },
    reordenar: function () {
      let ids = [];
      for (let i = 0; i < this.recaudaciones.length; i++)
        ids.push(this.recaudaciones[i].id);
      axios
        .post(url + "/logistica/recaudaciones", {
          pedidos: ids,
        })
        .then(() => { })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    subir: function (index) {
      let tmp = this.recaudaciones[index];
      this.recaudaciones[index] = this.recaudaciones[index - 1];
      this.recaudaciones[index - 1] = tmp;
      this.$forceUpdate();
      this.reordenar();
    },
    bajar: function (index) {
      let tmp = this.recaudaciones[index];
      this.recaudaciones[index] = this.recaudaciones[index + 1];
      this.recaudaciones[index + 1] = tmp;
      this.$forceUpdate();
      this.reordenar();
    },
    consultar: function () {
      if (
        !this.cambiarOrden &&
        !this.asignandoItems &&
        !this.mostrandoAsignaciones
      )
        this.$refs.recaudaciones.loadRows();
      else if (this.mostrandoAsignaciones)
        this.$refs.recaudacionesAsignadas.loadRows();
      else {
        if (this.selectedRuta == null) {
          swal("Debe seleccionar una ruta.", "Aviso", "warning");
        } else if (this.form.dia_cobro === "") {
          swal("Debe seleccionar el día de cobro.", "Aviso", "warning");
        } else {
          let params = JSON.parse(JSON.stringify(this.form));
          params.items = null;
          axios
            .get(url + "/logistica/orden-recaudaciones", {
              params: params,
            })
            .then(({ data }) => {
              this.recaudaciones = data.recaudaciones;
              if (data.items != null) {
                this.form.items.splice(0, this.form.items.length);
                for (let i = 0; i < data.items.length; i++) {
                  this.form.items.push({
                    item_id: data.items[i].item_id,
                    descripcion_item: data.items[i].item.nombre,
                    cantidad: data.items[i].cantidad,
                    codigo_barra: data.items[i].codigo_barra,
                  });
                }
                this.form.referencia_movimiento = data.referencia_movimiento;
                this.form.recaudacion_id = data.recaudacion_id;
                this.form.fecha_inicio = data.fecha_inicio;
                if (data.recaudador != null) {
                  this.selectedRecaudador = data.recaudador;
                  this.form.recaudador_id = data.recaudador.id;
                }
                if (data.supervisor != null) {
                  this.selectedSupervisor = data.supervisor;
                  this.form.supervisor_id = data.supervisor.id;
                }
                this.form.movimientosAdicionales.splice(0, this.form.movimientosAdicionales.length);
                if (data.movimientos_adicionales != null) {
                  for (let i = 0; i < data.movimientos_adicionales.length; i++)
                    this.form.movimientosAdicionales.push({
                      'id': data.movimientos_adicionales[i].id,
                      'created_at': data.movimientos_adicionales[i].created_at,
                      'cantidad_items': data.movimientos_adicionales[i].cantidad_items,
                      'referencia_movimiento': data.movimientos_adicionales[i].referencia_movimiento
                    });
                }
              }
              this.recaudacionesConsultadas = true;
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      }
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    searchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=E&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/Recaudaciones.vue